var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoHexa = function SvgLogoHexa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 868,
    height: 982,
    viewBox: "0 0 868 982"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-hexa_svg__b",
    x1: "97.627%",
    x2: "1.57%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#465FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6E4EF6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logo-hexa_svg__a",
    d: "m532 18.475 369.013 213.05a64 64 0 0 1 32 55.425v426.1a64 64 0 0 1-32 55.425L532 981.525a64 64 0 0 1-64 0L98.987 768.475a64 64 0 0 1-32-55.425v-426.1a64 64 0 0 1 32-55.425L468 18.475a64 64 0 0 1 64 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-66 -9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo-hexa_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hexa_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#logo-hexa_svg__b)",
    xlinkHref: "#logo-hexa_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#logo-hexa_svg__b)",
    mask: "url(#logo-hexa_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12-12h1024v1024H-12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M314 354v-83h372v83H314zm235 0v375h-97V449.62L549 354z",
    mask: "url(#logo-hexa_svg__c)"
  }))));
};
export default SvgLogoHexa;